<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="60%">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Negozio</span>
                </v-card-title>
                <v-card-subtitle> ID: {{ shop.id }} </v-card-subtitle>
                <v-card-text>
                    <v-form ref="form">
                        <v-container>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        type="text"
                                        label="Descrizione"
                                        v-model="shop.description"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-select
                                        :items="shop_types"
                                        v-model="shop.type"
                                        label="Tipo"
                                        item-text="description"
                                        item-value="id"
                                    >
                                    </v-select>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        type="number"
                                        label="Metri quadri"
                                        prefix="MQ"
                                        v-model="shop.metri_quadri"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        type="text"
                                        label="Cod Stabilimento"
                                        v-model="shop.tb_codstab"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        type="text"
                                        label="Serie Def"
                                        v-model="shop.tb_seriedef"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        type="text"
                                        label="Magazzino"
                                        v-model="shop.us_magazzino"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        type="text"
                                        label="Reg. DDT"
                                        v-model="shop.us_regddt"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        type="text"
                                        label="Cod Franchise"
                                        v-model="shop.codice_franchise"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        type="text"
                                        label="Indirizzo"
                                        v-model="shop.address"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        type="text"
                                        label="Città"
                                        v-model="shop.city"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        type="text"
                                        label="CAP"
                                        v-model="shop.cap"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        type="text"
                                        label="Regione"
                                        v-model="shop.region"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        type="text"
                                        label="Location"
                                        v-model="shop.location"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-checkbox
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="shop.lotto_riordino_reference"
                                        label="Reference lotto riordino"
                                    />
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        type="number"
                                        label="Lotto Riordino (%)"
                                        v-model="shop.lotto_riordino"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        type="number"
                                        label="Fatturato Espositivo Lordo EBITDA"
                                        v-model="shop.fatturato_espositivo_lordo_ebitda"
                                        step="0.01"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        type="number"
                                        label="Break Even Point"
                                        v-model="shop.break_even_point"
                                        step="0.01"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-file-input
                                        label="Carica Pianta"
                                        filled
                                        prepend-icon="mdi-camera"
                                        accept="image/*"
                                        v-model="file"
                                    ></v-file-input>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn
                                        :loading="loading"
                                        :disabled="loading"
                                        color="blue-grey"
                                        class="ma-2 white--text"
                                        @click="uploadFile"
                                    >
                                        Upload
                                        <v-icon right dark>
                                            mdi-cloud-upload
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn
                                        :loading="loading"
                                        :disabled="loading"
                                        color="error"
                                        class="ma-2"
                                        @click="deleteShopFile"
                                        v-if="shop.plant_image"
                                    >
                                        Elimina
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-if="shop.plant_image">
                                <v-col>
                                    <v-img :src="shop.plant_image" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">
                        Close
                    </v-btn>
                    <v-btn color="primary" @click="saved()"> Save </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import requests from "../../requests";
export default {
    props: {
        shop: {
            type: Object,
            default: {},
        },
        open: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        open(newVal) {
            if (newVal) this.dialog = true;
            else this.dialog = false;
        },
        dialog(newVal) {
            if (!newVal) this.onClosed();
        },
    },

    data: () => ({
        dialog: false,
        shop_types: [
            {
                id: "shop",
                description: "Shop",
            },
            {
                id: "franchise",
                description: "Franshise",
            },
        ],
        file: null,
        loading: false,
    }),

    methods: {
        uploadFile() {
            this.loading = true;
            requests.uploadShopFile(this.file, this.shop.id).then((res) => {
                this.loading = false;
                this.shop.plant_image = res.data.plant_image;
            });
        },

        deleteShopFile() {
            if (window.confirm("Cancellare l'immagine?")) {
                this.loading = true;
                requests.deleteShopFile(this.shop.id).then((res) => {
                    this.loading = false;
                    this.shop.plant_image = null;
                });
            }
        },
        onClosed() {
            this.$emit("onClose");
        },
        saved() {
            this.$emit("onSave", _.clone(this.shop));
        },
    },
};
</script>
